import { useWriteContract } from "wagmi";
import { PRESALE_CONTRACT_ADDRESS } from "../../../constants";
import { presaleAbi } from "../../../abis/presaleAbi";
import { parseEther } from "viem";
import { handleWriteContractError } from "../../../helpers";
import { toast } from "react-toastify";

export function useBuyWithBNB() {
  const { data, error, writeContractAsync, isPending, isSuccess } =
    useWriteContract();
   
  const buyWithBNB = async ({
    presaleId,
    amountOfTokensToBuy,
    bnbToSpend,
    referrer
  }: {
    presaleId: bigint;
    amountOfTokensToBuy: bigint;
    bnbToSpend: number;
    referrer: `0x${string}`;
  }) => {
    try {
      return await writeContractAsync({
        address: PRESALE_CONTRACT_ADDRESS,
        abi: presaleAbi,
        functionName: "buyWithEth",
        args: [presaleId, amountOfTokensToBuy, referrer],
        value: parseEther(`${bnbToSpend}`),
      }).then(() => toast.success("Transaction successfully submitted"));
    } catch (error) {
      return null;
    }
  };
  if (error) {
    return handleWriteContractError(error);
  }

  if (!data && !buyWithBNB) return null;

  return { buyWithBNBHash: data, buyWithBNB, error, isPending, isSuccess };
}
